import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api } from "../api/client";
import { Spinner } from "../components/UI";

export default function MeineMitzeichnungen() {
  const [liste, setListe] = useState(null);
  const [kommentare, setKommentare] = useState({});

  const laden = () => api.getMeineMitzeichnungen().then(setListe);
  useEffect(() => { laden(); }, []);

  if (!liste) return <Spinner />;

  const entscheiden = async (vorlage_id, mitzeichnung_id, entscheidung) => {
    await api.mitzeichnungEntscheiden(vorlage_id, mitzeichnung_id, entscheidung, kommentare[mitzeichnung_id] || "");
    laden();
  };

  return (
    <div style={{ padding: 24, maxWidth: 700 }}>
      <h1 style={{ fontSize: 20, fontWeight: 700, marginBottom: 20 }}>Meine Mitzeichnungen</h1>

      {liste.length === 0 && (
        <div style={{ color: "#999", fontSize: 13 }}>Aktuell keine offenen Mitzeichnungen für dich.</div>
      )}

      {liste.map(m => (
        <div key={m.mitzeichnung_id} className="card" style={{ padding: 16, marginBottom: 12 }}>
          <Link to={`/vorlagen/${m.vorlage_id}`} style={{ fontWeight: 600 }}>{m.vorlage_titel}</Link>
          {m.reihenfolge && <div style={{ fontSize: 12, color: "#999" }}>Position {m.reihenfolge} in der Reihenfolge</div>}
          <textarea className="form-control" placeholder="Kommentar (optional)" rows={2}
                    style={{ marginTop: 8, marginBottom: 8 }}
                    value={kommentare[m.mitzeichnung_id] || ""}
                    onChange={e => setKommentare(k => ({ ...k, [m.mitzeichnung_id]: e.target.value }))} />
          <div style={{ display: "flex", gap: 8 }}>
            <button className="btn btn-primary" onClick={() => entscheiden(m.vorlage_id, m.mitzeichnung_id, "zustimmen")}>Zustimmen</button>
            <button className="btn btn-secondary" onClick={() => entscheiden(m.vorlage_id, m.mitzeichnung_id, "rueckgabe")}>Rückgabe</button>
            <button className="btn btn-secondary" onClick={() => entscheiden(m.vorlage_id, m.mitzeichnung_id, "ablehnen")}>Ablehnen</button>
          </div>
        </div>
      ))}
    </div>
  );
}
